import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Footer from './Footer';

interface MonitoringPageMobileProps {
  t: any;
  isRTL: boolean;
}

const MonitoringContainer = styled.div`
  min-height: 100vh;
  background: white;
  padding: 1rem 1rem 0 1rem;
  padding-top: 100px;
`;

const Container = styled.div`
  max-width: 100%;
  margin: 0 auto;
`;

const Header = styled.div<{ $isRTL: boolean }>`
  text-align: ${props => props.$isRTL ? 'right' : 'left'};
  margin-bottom: 2rem;
  direction: ${props => props.$isRTL ? 'rtl' : 'ltr'};
`;

const MainTitle = styled.h1<{ $isRTL: boolean }>`
  font-size: 2rem;
  color: #1f2937;
  margin: 0 0 0.75rem 0;
  font-weight: 700;
  line-height: 1.2;
  font-family: ${props => props.$isRTL ? 
    "'Fustat', 'Amiri', 'Noto Sans Arabic', 'Arial', sans-serif" : 
    "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif"};
`;

const Subtitle = styled.p<{ $isRTL: boolean }>`
  font-size: 1rem;
  color: #1f2937;
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
  font-family: ${props => props.$isRTL ? 
    "'Fustat', 'Amiri', 'Noto Sans Arabic', 'Arial', sans-serif" : 
    "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif"};
`;

const ContentSection = styled(motion.div)`
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  margin-bottom: 2rem;
`;

const ContentGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const Paragraph = styled.p`
  font-size: 0.95rem;
  color: #374151;
  line-height: 1.6;
  margin: 0;
  text-align: justify;
  
  strong {
    color: #1f2937;
    font-weight: 600;
  }
`;

const HighlightText = styled.span`
  color: #dc2626;
  font-weight: 600;
`;

const ProviderSection = styled.div`
  background: white;
  border: 2px solid #d1d5db;
  border-radius: 12px;
  padding: 1.25rem;
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
`;

const ProviderText = styled.p`
  font-size: 0.95rem;
  color: #1f2937;
  margin: 0;
  font-weight: 500;
`;

const ProviderLogo = styled.img`
  max-width: 100px;
  height: auto;
  object-fit: contain;
`;

const MonitoringPageMobile: React.FC<MonitoringPageMobileProps> = ({ t, isRTL }) => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MonitoringContainer>
        <Container>
          <Header $isRTL={isRTL}>
            <MainTitle $isRTL={isRTL}>{t.monitoringPageTitle}</MainTitle>
            <Subtitle $isRTL={isRTL}>{t.monitoringPageSubtitle}</Subtitle>
          </Header>

          <ContentSection
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <ContentGrid>
              <Paragraph>
                <strong>{t.techyid}</strong> {t.monitoringPageContent1}
              </Paragraph>

              <Paragraph>
                {t.monitoringPageContent2}
              </Paragraph>
            </ContentGrid>

            <ProviderSection>
              <ProviderText>
                {t.monitoringPageProviderText}
              </ProviderText>
              <ProviderLogo
                src="/images/partners/cahors.png"
                alt={t.monitoringPageCahorsAlt}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = '/images/logo.png';
                }}
              />
            </ProviderSection>
          </ContentSection>
        </Container>
      </MonitoringContainer>
      <Footer t={t} isRTL={isRTL} />
    </>
  );
};

export default MonitoringPageMobile; 